import {
  Typography,
  Box,
  CircularProgress,
  MenuItem,
  Button,
  Stack,
  Chip,
  Link,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Grid,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import classnames from "classnames";
import moment from "moment";
import { RootState, useAppSelector, useAppDispatch } from "../../store/store";
import { colorIndexData } from "../newDashboard/listViewAccordian";
import FlagIcon from "@mui/icons-material/Flag";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ModeStandbyIcon from "@mui/icons-material/ModeStandby";
import Tooltip from "@mui/material/Tooltip";
import { keyframes } from "@mui/system";

// Define keyframes for the animation
const ringAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(20deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

export default function NotificationItems(props: any) {
  const {
    notificationLoader,
    updateAllNotificationStatus,
    updateNotificationReadStatus,
    updateNotificationReadStatusButNoRedirect,
    themeMode,
    page,
    setPage,
    isNormalNotificationCall,
    notificationType,
    setNotificationType,
    userNotificationsAll,
  } = props;

  const [notificationTypeList, setNotificationTypeList] = useState<any>([]);
  const [notificationTotalPage, setNotificationTotalPage] = useState<number>(0);
  const [notificationTotal, setNotificationTotal] = useState<number>(0);
  const [notificationTotalUnread, setNotificationTotalUnread] =
    useState<number>(0);
  const [notificationTotalRead, setNotificationTotalRead] = useState<number>(0);
  const [markAllAsReadStatus, setMarkAllAsReadStatus] = useState(false);
  const { userData, isInitialLogin, routesHistory } = useAppSelector(
    (state: RootState) => state.authReducer
  );
  const [IsLoadMoreVisible, setIsLoadMoreVisible] = useState(true);

  useEffect(() => {
    const totalPage = userNotificationsAll?.totalPage;
    const totalNoti = userNotificationsAll?.count || 0;
    const totalUnread = Math.abs(userNotificationsAll?.unread) || 0;
    const totalRead = Math.abs(userNotificationsAll?.read) || 0;

    if (totalUnread === 0) {
      setMarkAllAsReadStatus(false);
    }

    setNotificationTotalPage(totalPage);
    setNotificationTotalUnread(totalUnread);
    setNotificationTotalRead(totalRead);
    setNotificationTotal(totalNoti);

    const allNotifications =
      userNotificationsAll?.notificationsAll?.notifications;
    if (notificationType === "all") {
      setNotificationTypeList(allNotifications);
      if (totalNoti === allNotifications?.length) {
        setIsLoadMoreVisible(false);
      } else {
        setIsLoadMoreVisible(true);
      }
    } else if (notificationType === "read") {
      const filterNoti = userNotificationsAll?.notificationsRead?.notifications;
      setNotificationTypeList(filterNoti);
      if (totalRead === filterNoti?.length) {
        setIsLoadMoreVisible(false);
      } else {
        setIsLoadMoreVisible(true);
      }
    } else if (notificationType === "unread") {
      const filterNoti =
        userNotificationsAll?.notificationsUnRead?.notifications;
      setNotificationTypeList(filterNoti);
      if (totalUnread === filterNoti?.length) {
        setIsLoadMoreVisible(false);
      } else {
        setIsLoadMoreVisible(true);
      }
    }
  }, [userNotificationsAll, notificationType]);

  // For load more notification when user scroll to end
  // useEffect(() => {
  //   const boxElement:any = document.getElementById("notificationContent");
  //   boxElement.addEventListener("scroll", handleScroll);
  //   return () => {
  //     boxElement.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  // const handleScroll = async (event:any) => {
  //   const boxElement = event.target;
  //   const { scrollTop, clientHeight, scrollHeight } = boxElement;
  //   // Check if user has scrolled to the bottom of the Box component
  //   if (Math.round(scrollHeight - scrollTop) === clientHeight || Math.round(scrollHeight - scrollTop) === clientHeight + 1) {
  //     // Fetch more notifications
  //     setPage((pre: any) => pre + 1)
  //   }
  // };

  const markAllAsRead = () => {
    setMarkAllAsReadStatus(!markAllAsReadStatus);
    // setTimeout(() => {
    updateAllNotificationStatus();
    // }, 500);
  };

  return (
    <>
      {notificationLoader && isNormalNotificationCall && (
        <Box
          sx={{
            width: "100%",
            borderRadius: "0 !important",
            background: "rgba(0,0,0,0.2)",
            position: "absolute",
            bottom: 0,
            zIndex: "3 !important",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress size={32} />
        </Box>
      )}

      <Box
        sx={{
          px: 2,
          pb: 1,
          // display: "flex",
          // alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #b9aeae",
        }}
      >
        <Box sx={{ pb: 1, display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6" sx={{ fontSize: "1.25rem !important" }}>
            Notifications
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: 'wrap' }}>
          <Box sx={{ display: 'flex', flexWrap: "wrap", gap: 1 }}>
            <Chip
              sx={{
                width: "auto",
                minWidth: "80px",
                color: "#000",
                fontSize: "13px",
              }}
              className={classnames({
                activeMapFloor: notificationType === "all",
              })}
              variant="outlined"
              label={
                <>
                  All
                  <span
                    style={{
                      border: `1px solid ${notificationType === "all" ? "#FFFFFF" : "#000000"
                        }`,
                      paddingLeft: "4px",
                      paddingRight: "4px",
                      borderRadius: "16px",
                      marginLeft: "2px",
                    }}
                  >
                    {notificationTotal}
                  </span>
                </>
              }
              onClick={() => {
                setNotificationType("all");
                localStorage.setItem("notificationType", "all");
              }}
            />

            <Chip
              sx={{
                width: "auto",
                minWidth: "80px",
                color: "#000",
                fontSize: "13px",
                // backgroundColor: "#E9EDF1",
              }}
              className={classnames({
                activeMapFloor: notificationType === "read",
              })}
              variant="outlined"
              label={
                <>
                  Read{" "}
                  <span
                    style={{
                      border: `1px solid ${notificationType === "read" ? "#FFFFFF" : "#000000"
                        }`,
                      paddingLeft: "4px",
                      paddingRight: "4px",
                      borderRadius: "16px",
                      marginLeft: "2px",
                    }}
                  >
                    {notificationTotalRead}
                  </span>
                </>
              }
              onClick={() => {
                setNotificationType("read");
                localStorage.setItem("notificationType", "read");
              }}
            />

            <Chip
              sx={{
                width: "auto",
                minWidth: "80px",
                color: "#000",
                fontSize: "13px",
                // backgroundColor: "#E9EDF1",
              }}
              className={classnames({
                activeMapFloor: notificationType === "unread",
              })}
              variant="outlined"
              label={
                <>
                  Unread{" "}
                  <span
                    style={{
                      border: `1px solid ${notificationType === "unread" ? "#FFFFFF" : "#000000"
                        }`,
                      paddingLeft: "4px",
                      paddingRight: "4px",
                      borderRadius: "16px",
                      marginLeft: "2px",
                    }}
                  >
                    {notificationTotalUnread}
                  </span>
                </>
              }
              onClick={() => {
                setNotificationType("unread");
                localStorage.setItem("notificationType", "unread");
              }}
            />
          </Box>
          {(notificationTotalUnread > 0) && (
            <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
              {markAllAsReadStatus && <CircularProgress size={15} />}
              <Typography
                onClick={() => markAllAsRead()}
                sx={{
                  ":hover": {
                    textDecoration: "underline",
                    cursor: "pointer",
                  },
                }}
              >
                Mark all as read
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      <Box
        id={"notificationContent"}
        sx={{
          height: "auto",
          maxHeight: "420px",
          overflowY: "auto",
          zIndex: "9999", // Increase z-index value
        }}
      >
        {notificationTypeList?.length > 0 ? (
          notificationTypeList?.map((item: any, index: number) => {
            return (
              <Box onClick={() => updateNotificationReadStatus(item)}
                key={index} sx={{ borderBottom: "2px solid #577ec6", px: 2, py: 1, backgroundColor: !item?.is_read ? "#ECEBEB" : "", ":hover": { backgroundColor: "#ECEBEB", }, cursor: "pointer" }}>
                <Box sx={{ display: "flex", justifyContent: "end", alignItems: 'center', }}>
                  <Tooltip placement="left" title={item?.is_read ? "Mark as unread" : "Mark as read"} arrow>
                    <ModeStandbyIcon
                      onClick={(e) => {
                        e.stopPropagation(); // Stop propagation to parent onClick event
                        updateNotificationReadStatusButNoRedirect(item);
                      }}
                      sx={{
                        color: `${!item?.is_read ? "#22519c" : "#4e4e4e"}`, height: "21px !important",
                        width: "18px !important",
                        ":hover": {
                          color: !item?.is_read ? "#4e4e4e" : "#22519c", // Change to the desired hover color
                        },
                      }}
                    />
                  </Tooltip>
                  <Typography variant="caption" sx={{ color: "#4e4e4e", ml: "5px" }}>
                    {moment
                      ?.unix(item?.sentTime / 1000)
                      ?.utc(false)
                      ?.tz(userData?.timezone || moment.tz.guess())
                      .format("MM/DD/YY - h:mm A")}
                  </Typography>
                </Box>
                <Grid container>
                  <Grid item xs={1} >
                    <Box sx={{ height: '30px', width: "30px", borderRadius: "50%", backgroundColor: "#FFFFFF", display: 'flex', border: "1px solid #ECEBEB", justifyContent: 'center', alignItems: "center" }}>
                      <FlagIcon sx={{ color: `${colorIndexData[item?.index]}`, fontSize: "24px", }} />
                    </Box>
                  </Grid>
                  <Grid item xs={11}>
                    <Box sx={{ pl: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap", }}>
                        <Typography sx={{ color: "#000" }}>
                          <strong>{`Status -`} </strong>
                        </Typography>&nbsp;
                        <Typography sx={{ color: "#4e4e4e", ":hover": { textDecoration: "underline" } }}>
                          {item.status}
                        </Typography>
                      </Box>
                      <Box sx={{ pl: 1, display: "flex", flexWrap: "wrap" }}>
                        <Typography sx={{ color: "#000" }}>
                          <strong>{`Characteristic -`} </strong>
                        </Typography>&nbsp;
                        <Typography sx={{ color: "#4e4e4e", ":hover": { textDecoration: "underline" } }}>
                          {item.substance}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ pl: 1, display: "flex", gap: "5px" }}>
                      <Typography sx={{ color: "#000" }}>
                        <strong>{`Location -`} </strong>
                      </Typography>
                      <Typography sx={{ color: "#4e4e4e", ":hover": { textDecoration: "underline" } }}>
                        {item.location}
                      </Typography>
                    </Box>
                    <Box sx={{ pl: 1, }}>
                      <Typography sx={{ color: "#4e4e4e", ":hover": { textDecoration: "underline" } }}>
                        {item.text}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Box >
            )
          })
        ) : (
          <Box
            sx={{
              p: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <NotificationsIcon
              sx={{
                fontSize: "40px",
                mb: 2,
                animation: `${ringAnimation} 0.5s ease infinite`,
              }}
            />
            <Typography variant="h6">No Notifications</Typography>
          </Box>
        )}
        {notificationTotalPage - 1 > page &&
          IsLoadMoreVisible &&
          (notificationType === "unread"
            ? notificationTotalUnread > 10
            : notificationType === "read"
              ? notificationTotalRead > 10
              : true) && (
            <MenuItem
              onClick={() => setPage((pre: any) => pre + 1)}
              sx={{
                marginTop:
                  notificationLoader && isNormalNotificationCall
                    ? "10px"
                    : "0px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                // onClick={() => setPage((pre: any) => pre + 1)}
                sx={{ width: "100%", borderRadius: "0 !important" }}
              >
                {!notificationLoader || !isNormalNotificationCall
                  ? "Load More"
                  : " "}
              </Button>
            </MenuItem>
          )}
      </Box >
    </>
  );
}
